import type { FC } from 'react'

import ButtonLink from '@/components/landing/button-link'
import KineticWordmark from '@/components/landing/kinetic-wordmark'
import { Accent, Eyebrow } from '@/components/landing/section-heading'
import { CONTACT_EMAIL, LINKS } from '@/constants/kinematic'

const FinalCta: FC = () => {
    return (
        <section id='contact' aria-labelledby='contact-title' className='relative overflow-hidden bg-ember text-ink'>
            <div aria-hidden='true' className='noise pointer-events-none absolute inset-0 opacity-[0.14] mix-blend-multiply' />

            <div className='relative mx-auto max-w-[1320px] px-5 pt-24 md:px-8 md:pt-32'>
                <div className='grid gap-10 lg:grid-cols-12 lg:items-end'>
                    <div className='lg:col-span-7'>
                        <Eyebrow index='08' label='Start' tone='light' />

                        <h2
                            id='contact-title'
                            className='mt-6 text-balance text-[clamp(2.75rem,6.4vw,6rem)] font-semibold leading-[0.92] tracking-[-0.035em] stretch-condensed'
                        >
                            Open the sandbox today. Go live <Accent>when you are ready.</Accent>
                        </h2>
                    </div>

                    <div className='lg:col-span-5'>
                        <p className='text-lg leading-relaxed text-ink/80'>
                            The sandbox mirrors live mode with test credits and records every bet on Solana devnet, so you can wire everything up before you pay anything.
                        </p>

                        <div className='mt-8 flex flex-wrap gap-3'>
                            <ButtonLink href={LINKS.signUp} variant='ink' external>
                                Start free in sandbox
                            </ButtonLink>
                            <ButtonLink href={LINKS.email} variant='outline-ink' arrow={false}>
                                {CONTACT_EMAIL}
                            </ButtonLink>
                        </div>

                        <p className='mt-4 font-mono text-[11px] text-ink/80'>
                            We reply within one business day.
                        </p>
                    </div>
                </div>
            </div>

            <KineticWordmark className='relative mt-16 md:mt-24' />
        </section>
    )
}

export default FinalCta
